webpackJsonp([56552065432377],{

/***/ 1392:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Simple iOS Sprite Kit Game Tutorial","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/simple-ios-sprite-kit-game-tutorial","createdAt":"2013-11-23T03:18:16.727Z","blogAuthor":{"fields":{"name":"Megha Gulati","slug":"blog/author/megha-gulati"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5lD5UmI8SIMSwgYu6iKuaW/2815a5dedb7dde80f2eb72c8ec9ba39a/blog-post-blog-simple-ios-sprite-kit-game-tutorial.png"}}}}}]},"authorJson":{"name":"Megha Gulati","slug":"blog/author/megha-gulati","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/megha-gulati"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-megha-gulati-b455b6de8f873b4e31f2.js